<shared-ceops></shared-ceops>

<div id="app-container"
	 class="family-container"
	 role="main">
	<router-outlet></router-outlet>

	@if(featureFlags()?.compareCheckboxEnabled) {
		<plp-components-product-list-snackbar></plp-components-product-list-snackbar>
		<plp-components-compare-painted-door-modal></plp-components-compare-painted-door-modal>
	}

	<ng-template #modalContent>
		<plp-components-compare-grid
			class="hmf-pb-s hmf-pb-sm-m">
		</plp-components-compare-grid>
	</ng-template>
</div>
